export default "__VITE_ASSET__DnmWvUnB__"